export default "__VITE_ASSET__f35e245d__"